<template>
  <div id="regist-input">
    <dd-header
      :headerType=1
    />
    <div id="container">
      <div id="content">
        <div class="title">
          <h2>パスワードのリセット</h2>
        </div>
        <div class="input_list">
          <div v-if="errorMessage.text"><label class="error_text">{{ errorMessage.text }}</label></div>
          <div v-if="errors.email"><label class="error_text">{{errors.email}}</label></div>
          <ul>
            <li class="list_key">
              <label class=" text_left">ご登録メールアドレス</label>
            </li>
            <li class="list_box">
              <input type="text" v-model.trim="mailAddress" placeholder="メールアドレスを入力してください。"/>
            </li>
            <li class="center_button">
              <button class="main_btn send_btn" @click="sendMail()">送信</button>
            </li>
          </ul>
          <div>※受信制限をされている方は、「<label class="weighty">@domans.co.jp</label>」からのメールを受信許可に設定してください</div>
          <div>※メールアドレスを間違えて入力してしまった場合は、再度パスワードのリセット手続きを行ってください。</div>
        </div>
        <div class="center_button">
          <button class="main_btn cancel_btn" @click="toLogin()">戻る</button>
        </div>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'
import * as Check from '../../utils/Check'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
import LoadingModal from '../../components/common/LoadingModal'

// Module
import Header from '../components/common/DcHeader'

export default {
  components: {
    'dd-header': Header,
    'dd-loading-modal': LoadingModal
  },
  props: {
  },
  data () {
    return {
      mailAddress: '',
      errors: {},
      submitDisable: false,
      /** 共通エラーメッセージ */
      errorMessage: { text: '' }
    }
  },
  methods: {
    toLogin: function () {
      this.$router.push('/mmstyle/login')
    },
    sendMail: function () {
      if (this.submitDisable) return
      this.submitDisable = true
      this.$refs.loadingModalRef.showModal(true)

      this.errorMessage = {}
      this.errors = {}
      this.validatedReqire()
      if (Object.keys(this.errors).length !== 0) {
        this.$refs.loadingModalRef.showModal(false)
        this.submitDisable = false
        return
      }
      App.removeLocalStorage(DC_STORAGE_KEY.USER_DATA)

      let payload = {
        mailAddress: this.mailAddress
      }
      axios.post(DC_URL.USER + '/reset/send-mail', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.$set(this.errorMessage, 'text', response.data.errorMessage)
          } else {
            this.$router.push('/mmstyle/user/reset/confirm')
          }
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
        .finally(() => {
          this.$refs.loadingModalRef.showModal(false)
          this.submitDisable = false
        })
    },
    validatedReqire: function () {
      if (!Check.isMail(this.mailAddress)) {
        this.$set(this.errors, 'email', 'メールアドレスの形式ではありません。')
      }
    }
  },
  created () {
    App.removeLocalStorage(DC_STORAGE_KEY.PASSWORD_DATA)
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/input-list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/PasswordResetInput.vue